import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material'
import { TitleAndContent } from 'src/features/reportExport/detail/components/TitleAndContent'

// 件数が多い欄はダイアログを縦に伸ばさず、固定高さのスクロール領域に収める
const SCROLL_AREA_MAX_HEIGHT = 200

type Props = {
  isSendingData: boolean
  onCancel: () => void
  onOk: () => void
  open: boolean
  sendingDataAsString: {
    dateFromTo: string
    outputFileName: string
    places: string
    placeCount: number
    templateNames: string
    templateCount: number
  }
}

/**
 * 件数が複数のときはタイトルに「(N件)」を付け、内容を固定高さのスクロール領域で
 * 全件表示する。単一(または「すべての現場」等の集約表示)のときは件数を付けず素表示。
 */
const CountableField = ({
  title,
  count,
  content,
}: {
  title: string
  count: number
  content: string
}) => (
  <TitleAndContent title={count > 1 ? `${title} (${count}件)` : title}>
    {count > 1 ? (
      <Box sx={{ maxHeight: SCROLL_AREA_MAX_HEIGHT, overflowY: 'auto' }}>
        {content}
      </Box>
    ) : (
      content
    )}
  </TitleAndContent>
)

export const ReportExportDetailSendConfirmationV2 = (props: Props) => {
  const {
    isSendingData,
    onCancel,
    onOk,
    open,
    sendingDataAsString: {
      dateFromTo,
      outputFileName,
      places,
      placeCount,
      templateNames,
      templateCount,
    },
  } = props

  return (
    <Dialog
      open={open}
      onClose={isSendingData ? undefined : onCancel}
      aria-labelledby="send-confirmation-v2-dialog-title"
      data-testid="report-export-confirm-dialog-v2"
      maxWidth="sm"
    >
      <DialogTitle id="send-confirmation-v2-dialog-title">
        出力の確認
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={2}>
          <CountableField
            title="ひな形"
            count={templateCount}
            content={templateNames}
          />
          <CountableField title="現場" count={placeCount} content={places} />
          <TitleAndContent title="期間">{dateFromTo}</TitleAndContent>
          <TitleAndContent title="出力ファイル名">
            {outputFileName}
          </TitleAndContent>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isSendingData}>
          キャンセル
        </Button>
        <Button onClick={onOk} disabled={isSendingData} variant="contained">
          {isSendingData ? '処理中...' : '出力'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
